import {useDispatch, useSelector} from "react-redux";
//import '../css/cart.css'
import {removeFromCart} from "../redux/reducers/storageSlice";
import CartCard from "../components/CartCard";
import { Link } from "react-router-dom";
export default function Cart() {
    const dispatch = useDispatch()
    const { cart, total } = useSelector(state => state.storages)
    const removeItemFromCart = (product) => dispatch(removeFromCart(product))

    return (
        <div className="container mx-auto py-[5%]">
            <div className="flex shadow-md my-10">
              <div className="w-3/4 bg-white px-10 py-10">
                <div className="flex justify-between border-b pb-8">
                  <h1 className="font-semibold text-2xl">Your Selection</h1>
                  <h2 className="font-semibold text-2xl">{cart.length} Spaces</h2>
                </div>
                <div className="flex mt-10 mb-5">
                  <h3 className="font-semibold text-gray-600 text-xs uppercase w-2/5">Storage Details</h3>
                  <h3 className="font-semibold text-gray-600 text-xs uppercase w-1/5 text-center">Quantity</h3>
                  <h3 className="font-semibold text-gray-600 text-xs uppercase w-1/5 text-center">Rates</h3>
                  <h3 className="font-semibold text-gray-600 text-xs uppercase w-1/5 text-center">Total</h3>
                </div>

                {cart.map((product) => (
                               <CartCard
                                key={product.id}
                                product={product}
                                removeFromCart={removeItemFromCart}/>
                            ))}

                <Link navigate to="/storages" className="flex font-semibold text-indigo-600 text-sm mt-10">
                
                  <svg className="fill-current mr-2 text-indigo-600 w-4" viewBox="0 0 448 512"><path d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"/></svg>
                  Continue Booking
                </Link>
              </div>
                
              <div id="summary" className="w-1/4 px-8 py-10">
                <h1 className="font-semibold text-2xl border-b pb-8">Booking Summary</h1>
                <div className="flex justify-between mt-10 mb-5">
                  <span className="font-semibold text-sm uppercase">{cart.length} Spaces</span>
                  <span className="font-semibold text-sm">{cart.length}</span>
                </div>
                
                <div className="py-10">
                  <label for="promo" className="font-semibold inline-block mb-3 text-sm uppercase">Promo Code</label>
                  <input type="text" id="promo" placeholder="Enter your code" className="p-2 text-sm w-full" />
                </div>
                <button className="bg-custom-gold-color hover:bg-orange-200 px-5 py-2 text-sm text-white uppercase">Apply</button>
                <div className="border-t mt-8">
                  <div className="flex font-semibold justify-between py-6 text-sm uppercase">
                    <span>Total cost</span>
                    {/*console.log(">>>.", cart)*/}
                    <span>Ksh. {total}</span>
                  </div>
                  <button className="bg-main-blue-color font-semibold hover:bg-white py-3 text-sm text-white uppercase w-full"><Link to="/checkoutpage">Checkout</Link></button>
                </div>
              </div>
                
            </div>
        </div>
    )
}
